'use strict';

import Actions from './actions';
import Button from '../../../components/form/button.jsx';
import ControlGroup from '../../../components/form/control-group.jsx';
import React from 'react';
import Spinner from '../../../components/form/spinner.jsx';
import Store from './store';
import TextControl from '../../../components/form/text-control.jsx';
import PropTypes from 'prop-types';
import LinkState from '../../../helpers/link-state.js';



const propTypes = {

    accountOnly : PropTypes.bool,
    error: PropTypes.string,
    autoFocus: PropTypes.string,
    loading : PropTypes.bool,
    success : PropTypes.bool,
    hasError : PropTypes.object,
    help : PropTypes.object,
    signin: PropTypes.func,
    cancel: PropTypes.func,
    recover: PropTypes.func,
    autoLoginAfterRegister: PropTypes.bool
};

class Register extends React.Component {
    constructor(props) {

        super(props);

        this.els = {};
        this.state = {
            email: '',
            title: '',
            first: '',
            middle: '',
            last: '',
            suffix: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            country: ''
        };
    }

    componentDidMount() {

        if (this.els.email) {
            this.els.email.focus();
        }
    }

    componentWillUnmount() {

        Actions.registerReset();
    }

    componentDidUpdate(prevProps){


        if ( (prevProps.autoFocus !== this.props.autoFocus) &&  this.props.autoFocus ){

            this.els[this.props.autoFocus].focus();
        }
    }

    onStoreChange() {

        this.setState(Store.getState());
    }

    /*
    cancel() {
        Actions.cancelCheckout();
    }*/

    handleSubmit(event) {

        event.preventDefault();
        event.stopPropagation();

        const data = {
            email: this.els.email.value(),
            password: this.els.password.value(),
            password_confirm: this.els.password_confirm.value(),
            //title: this.els.title.value(),
            first: this.els.first.value(),
            //middle: this.els.middle.value(),
            last: this.els.last.value(),
            //suffix: this.els.suffix.value(),
            //address1: this.els.address1.value(),
            //address2: this.els.address2.value(),
            //city: this.els.city.value(),
            //state: this.els.state.value(),
            //country: this.els.country.value(),
            //zip: this.els.zip.value()
        };
        if ( this.props.autoLoginAfterRegister) {
            Actions.registerUserAutoLogin(data, undefined, data.email, data.password, this.props.accountOnly);
        } else {
            Actions.registerUser(data, this.props.accountOnly);
        }
    }

    signin(event){

        event.preventDefault();
        event.stopPropagation();
        this.props.signin();
    }
    recover(event){

        event.preventDefault();
        event.stopPropagation();
        this.props.recover();
    }

    render() {

        const alerts = [];

        if (this.props.success) {
            alerts.push(<div key="success" className="alert alert-success">
                Success. Redirecting...
            </div>);
        }

        if (this.props.error && this.props.hasError.email_in_use) {
            alerts.push(<div key="danger" className="alert alert-danger">
                Email already in use.  <a onClick={this.signin.bind(this)} href="#">Sign In</a> or <a href="#" onClick={this.recover.bind(this)}>recover your password.</a>
            </div>);
        }
        else if (this.props.error) {
            alerts.push(<div key="danger" className="alert alert-danger">
                {this.props.error}
            </div>);
        }

        let formElements;

        if (!this.props.success) {
            formElements = <fieldset>
                <TextControl
                    ref={(c) => (this.els.email = c)}
                    onChange={LinkState.bind(this)}
                    name="email"
                    autoComplete="email"
                    type="email"
                    label="Email (required)"
                    hasError={this.props.hasError.email}
                    help={this.props.help.email}
                    disabled={this.props.loading}
                />
                <TextControl
                    ref={(c) => (this.els.password = c)}
                    onChange={LinkState.bind(this)}
                    name="password"
                    autoComplete="new-password"
                    label="Password (required)"
                    type="password"
                    hasError={this.props.hasError.password}
                    help={this.props.help.password}
                    disabled={this.props.loading}
                />
                <TextControl
                    ref={(c) => (this.els.password_confirm = c)}
                    onChange={LinkState.bind(this)}
                    name="password_confirm"
                    autoComplete="new-password"
                    label="Confirm Password (required)"
                    type="password"
                    hasError={this.props.hasError.password_confirm}
                    help={this.props.help.password_confirm}
                    disabled={this.props.loading}
                />
                {/*
                <TextControl
                    name="title"
                    label="Title"
                    autoComplete='honorific-prefix'
                    ref={(c) => (this.els.title = c)}
                    value={this.state.title}
                    onChange={LinkState.bind(this)}
                    hasError={this.props.hasError.title}
                    help={this.props.help.title}
                    disabled={this.props.loading}
                />
                */}
                <TextControl
                    name="first"
                    label="First name (required)"
                    autoComplete='given-name'
                    ref={(c) => (this.els.first = c)}
                    value={this.state.first}
                    onChange={LinkState.bind(this)}
                    hasError={this.props.hasError.first}
                    help={this.props.help.first}
                    disabled={this.props.loading}
                />
                {/*
                <TextControl
                    name="middle"
                    label="Middle name"
                    autoComplete='additional-name'
                    ref={(c) => (this.els.middle = c)}
                    value={this.state.middle}
                    onChange={LinkState.bind(this)}
                    hasError={this.props.hasError.middle}
                    help={this.props.help.middle}
                    disabled={this.props.loading}
                />
                */}
                <TextControl
                    name="last"
                    label="Last name (required)"
                    value={this.state.last}
                    autoComplete='family-name'
                    ref={(c) => (this.els.last = c)}
                    onChange={LinkState.bind(this)}
                    hasError={this.props.hasError.last}
                    help={this.props.help.last}
                    disabled={this.props.loading}
                />
                {/*
                <TextControl
                    name="suffix"
                    label="Suffix"
                    autoComplete='honorific-suffix'
                    ref={(c) => (this.els.suffix = c)}
                    value={this.state.suffix}
                    onChange={LinkState.bind(this)}
                    hasError={this.props.hasError.suffix}
                    help={this.props.help.last}
                    disabled={this.props.loading}
                />
                <TextControl
                    name="address1"
                    label="Address 1"
                    autoComplete='address-line1'
                    ref={(c) => (this.els.address1 = c)}
                    value={this.state.address1}
                    onChange={LinkState.bind(this)}
                    hasError={this.props.hasError.address1}
                    help={this.props.help.address1}
                    disabled={this.props.loading}
                />
                <TextControl
                    name="address2"
                    label="Address 2"
                    autoComplete='address-line2'
                    ref={(c) => (this.els.address2 = c)}
                    value={this.state.address2}
                    onChange={LinkState.bind(this)}
                    hasError={this.props.hasError.address2}
                    help={this.props.help.address2}
                    disabled={this.props.loading}
                />
                <TextControl
                    name="city"
                    label="City"
                    value={this.state.city}
                    ref={(c) => (this.els.city = c)}
                    onChange={LinkState.bind(this)}
                    hasError={this.props.hasError.city}
                    help={this.props.help.city}
                    disabled={this.props.loading}
                />
                <TextControl
                    name="state"
                    label="State"
                    value={this.state.state}
                    ref={(c) => (this.els.state = c)}
                    onChange={LinkState.bind(this)}
                    hasError={this.props.hasError.state}
                    help={this.props.help.state}
                    disabled={this.props.loading}
                />
                <TextControl
                    name="country"
                    label="Country"
                    autoComplete='country'
                    ref={(c) => (this.els.country = c)}
                    value={this.state.country}
                    onChange={LinkState.bind(this)}
                    hasError={this.props.hasError.country}
                    help={this.props.help.country}
                    disabled={this.props.loading}
                />
                <TextControl
                    name="zip"
                    label="Zip"
                    autoComplete='postal-code'
                    ref={(c) => (this.els.zip = c)}
                    value={this.state.zip}
                    onChange={LinkState.bind(this)}
                    hasError={this.props.hasError.zip}
                    help={this.props.help.zip}
                    disabled={this.props.loading}
                />
                */}

                <ControlGroup hideLabel={true} hideHelp={true}>
                    <Button
                        onClick={this.handleSubmit.bind(this)}
                        type="submit"
                        inputClasses={{ 'btn-primary': true }}
                        disabled={this.props.loading}>

                        Create Account
                        <Spinner space="left" show={this.props.loading} />
                    </Button>  <Button
                        type="button"
                        onClick={this.props.cancel}
                        inputClasses={{ 'btn-default': true }}
                        disabled={this.props.loading}>

                    Cancel
                    </Button>
                </ControlGroup>
            </fieldset>;
        }

        return (
            <section className='sor-signin'>
                <form>
                    {alerts}
                    {formElements}
                </form>
            </section>
        );
    }
}

Register.propTypes = propTypes;

export default Register;
